// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"28":"ccc2ae10","856":"45ec4ffb"}[chunkId] + ".js";
};